module.exports = __webpack_public_path__ + "static/media/ploni-light-aaa.2c1b1520.woff";